itsoftApp.createModule("tilting", function () {
    /* Store the element in el */
    let el = document.querySelector('.js-tilt');

    if (el) {
        let image = el.querySelector("img");

        /* Get the height and width of the element */
        const height = el.clientHeight
        const width = el.clientWidth

        /*
          * Add a listener for mousemove event
          * Which will trigger function 'handleMove'
          * On mousemove
          */

        /* Define function a */
        const handleMove = function (e) {
          /*
            * Get position of mouse cursor
            * With respect to the element
            * On mouseover
            */
          /* Store the x position */
          const xVal = e.offsetX
          /* Store the y position */
          const yVal = e.offsetY
          
          /*
            * Calculate rotation valuee along the Y-axis
            * Here the multiplier 20 is to
            * Control the rotation
            * You can change the value and see the results
            */
          const yRotation = 20 * ((xVal - width / 2) / width)
          
          /* Calculate the rotation along the X-axis */
          const xRotation = -20 * ((yVal - height / 2) / height)
          
          /* Generate string for CSS transform property */
          const string = 'perspective(1000px) rotateX(' + xRotation + 'deg) rotateY(' + yRotation + 'deg)'
          
          /* Apply the calculated transformation */
          image.style.transform = string;
        }

        el.addEventListener('mousemove', handleMove);

        /* Add listener for mouseout event, remove the rotation */
        el.addEventListener('mouseout', function() {
          image.style.transform = 'perspective(500px) rotateX(0) rotateY(0)'
        })
    }
});